import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Newspaper, Loader2, ExternalLink, RefreshCw } from "lucide-react";
import { api } from "../lib/api";

const ago = (iso) => {
  if (!iso) return "";
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 3600) return `${Math.max(1, Math.round(s / 60))}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
};

export const NewsModal = ({ open, onOpenChange, symbol }) => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");

  const load = () => {
    setLoading(true); setErr("");
    api.news().then((d) => { if (d.ok) setItems(d.data || []); else setErr(d.error || "Failed to load news"); })
      .catch(() => setErr("Failed to load news")).finally(() => setLoading(false));
  };
  useEffect(() => { if (open) load(); }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl bg-[#0b0d10] border-zinc-800 text-white" data-testid="news-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-sm font-semibold tracking-tight">
            <Newspaper size={16} className="text-amber-400" /> Finance News
            <button onClick={load} data-testid="news-refresh" className="ml-auto text-zinc-500 hover:text-amber-300"><RefreshCw size={13} /></button>
          </DialogTitle>
          <DialogDescription className="text-[11px] text-zinc-500">
            Live market headlines (APILayer · free plan is ~60-min delayed). Not an economic calendar.
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[420px] overflow-y-auto space-y-2 pr-1" data-testid="news-list">
          {loading ? (
            <div className="flex items-center justify-center gap-2 py-16 font-mono text-xs text-zinc-500"><Loader2 size={14} className="animate-spin" /> Loading…</div>
          ) : err ? (
            <div className="py-12 text-center font-mono text-xs text-rose-400">{err}</div>
          ) : !items.length ? (
            <div className="py-12 text-center font-mono text-xs text-zinc-500">No headlines.</div>
          ) : items.map((n, i) => (
            <a key={i} href={n.url} target="_blank" rel="noreferrer" data-testid={`news-item-${i}`}
              className="block rounded-lg border border-zinc-800 bg-zinc-950/60 p-3 transition-colors hover:border-amber-600/40">
              <div className="flex items-start justify-between gap-3">
                <div className="text-[13px] leading-snug text-zinc-100">{n.title}</div>
                <ExternalLink size={12} className="mt-0.5 shrink-0 text-zinc-600" />
              </div>
              <div className="mt-1.5 flex items-center gap-2 font-mono text-[10px] text-zinc-500">
                <span className="text-amber-400/80">{n.source}</span>
                <span>· {ago(n.published_at)}</span>
                {n.tickers?.length ? <span className="text-zinc-400">· {n.tickers.slice(0, 4).join(" ").toUpperCase()}</span> : null}
              </div>
            </a>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
